// extracted by mini-css-extract-plugin
export default {"footerLink":"styles_footerLink__YElz7","footerLinkFacebook":"styles_footerLinkFacebook__B+N5q","footerLinkInstagram":"styles_footerLinkInstagram__N+tQV"};